import { LockerIdentity } from './locker.types'

/**
 * Get the number shown on the locker bank, falling back to the SmartLocker door ID when the API has none for the door
 * @param locker - The locker's door ID and locker number
 * @returns The locker number, e.g. "21", or the door ID
 */
export const getLockerNumberLabel = ({ doorId, lockerNumber }: LockerIdentity): string => {
  return lockerNumber === null || lockerNumber === undefined ? doorId : `${lockerNumber}`
}

/**
 * Name a locker the way travelers and shoppers see it
 * @param locker - The locker's door ID and locker number
 * @returns The locker name, e.g. "Locker 21"
 */
export const formatLockerName = (locker: LockerIdentity): string => {
  return `Locker ${getLockerNumberLabel(locker)}`
}

/**
 * Name a locker for admins, keeping the SmartLocker door ID the locker operator uses
 * @param locker - The locker's door ID and locker number
 * @returns The locker name with its door ID, e.g. "Locker 21 (CAB2-03)"
 */
export const formatAdminLockerName = (locker: LockerIdentity): string => {
  const hasLockerNumber = locker.lockerNumber !== null && locker.lockerNumber !== undefined

  return hasLockerNumber ? `${formatLockerName(locker)} (${locker.doorId})` : formatLockerName(locker)
}
